import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickFilters = ({ 
  selectedCuisines, 
  onCuisineToggle, 
  selectedDietary, 
  onDietaryToggle,
  locationRadius,
  onRadiusChange
}) => {
  const cuisineOptions = [
    { value: 'indian', label: 'Indian', emoji: '🍛' },
    { value: 'thai', label: 'Thai', emoji: '🍜' },
    { value: 'mediterranean', label: 'Mediterranean', emoji: '🥙' },
    { value: 'chinese', label: 'Chinese', emoji: '🥢' },
    { value: 'italian', label: 'Italian', emoji: '🍝' },
    { value: 'mexican', label: 'Mexican', emoji: '🌮' },
    { value: 'cake', label: 'Cake', emoji: '🍰' },
    { value: 'sweets', label: 'Sweets', emoji: '🍬' }
  ];

  const dietaryOptions = [
    { value: 'vegetarian', label: 'Vegetarian', icon: 'Leaf' },
    { value: 'vegan', label: 'Vegan', icon: 'Sprout' },
    { value: 'gluten-free', label: 'Gluten-Free', icon: 'Wheat' },
    { value: 'halal', label: 'Halal', icon: 'Moon' }
  ];

  const radiusOptions = [
    { value: 5, label: '5 km' },
    { value: 10, label: '10 km' },
    { value: 15, label: '15 km' },
    { value: 20, label: '20 km' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6 mb-6">
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-semibold text-base md:text-lg">
            Cuisine Type
          </h3>
          {selectedCuisines?.length > 0 && (
            <button
              onClick={() => selectedCuisines?.forEach(c => onCuisineToggle(c))}
              className="text-sm text-primary hover:underline transition-smooth"
            >
              Clear all
            </button>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          {cuisineOptions?.map((cuisine) => (
            <button
              key={cuisine?.value}
              onClick={() => onCuisineToggle(cuisine?.value)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
                selectedCuisines?.includes(cuisine?.value)
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted hover:bg-muted/80'
              }`}
            >
              <span className="text-base">{cuisine?.emoji}</span>
              {cuisine?.label}
            </button>
          ))}
        </div>
      </div>
      {/* Dietary Preferences section disabled as requested */}
      <div>
        <h3 className="font-heading font-semibold text-base md:text-lg mb-3">
          Delivery Radius
        </h3>
        <div className="flex items-center gap-2">
          {radiusOptions?.map((option) => (
            <button
              key={option?.value}
              onClick={() => onRadiusChange(option?.value)}
              className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-smooth ${
                locationRadius === option?.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted hover:bg-muted/80'
              }`}
            >
              {option?.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickFilters;